import React from 'react';
import { FormError, Separator, Switch } from '~/components';

export const FormSwitch = ({
  value,
  title,
  label,
  description,
  preSwitchDescription,
  footer,
  onChange,
  disabled,
  error,
}: {
  value: boolean;
  title?: string;
  label?: string;
  preSwitchDescription?: string | React.ReactNode;
  description?: string;
  footer?: string | React.ReactNode;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  error?: string | null | undefined;
}) => {
  return (
    <div className="space-y-4">
      {title && <div>{title}</div>}

      <div className="rounded-xl border">
        {preSwitchDescription && (
          <>
            <div className="p-5">{preSwitchDescription}</div>

            <Separator />
          </>
        )}
        <div className="flex items-center gap-4 p-5">
          <Switch
            checked={value}
            onCheckedChange={onChange}
            disabled={disabled}
          />

          {label && (
            <label className="leading-none text-muted-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              {label}
            </label>
          )}
        </div>

        {description && (
          <>
            <Separator />

            <div className="p-5 text-muted-foreground">{description}</div>
          </>
        )}

        {error && (
          <>
            <Separator />

            <div className="p-5">
              <FormError error={error} />
            </div>
          </>
        )}

        {footer && (
          <>
            <Separator />

            <div className="p-5">{footer}</div>
          </>
        )}
      </div>
    </div>
  );
};
